let API_URL, BASE_URL, REACT_APP_HOMEPAGE_URL, PREFIX;

const getTenantFromURL = () => 
{
  const url = window.location.hostname;
  const tenantId = url.split('.')[0];  
  return url;  
};

const currentURL = getTenantFromURL();

if (currentURL === 'localhost') 
{
  API_URL = 'https://dan.ramatechno.com/api';
  BASE_URL = 'http://localhost:3000';
  REACT_APP_HOMEPAGE_URL = 'https://localhost:3000';
  PREFIX = 'sdm';
} else if (currentURL === 'ddsnacks.co.uk') 
{
  API_URL = 'https://testapi.rameegroup.co.in';
  BASE_URL = 'https://ddsnacks.co.uk';
  REACT_APP_HOMEPAGE_URL = 'https://ddsnacks.co.uk';
  PREFIX = 'dds';
} else if (currentURL === 'sales.ddsnacks.co.uk') 
{
  API_URL = 'https://api.rameesystems.com';
  BASE_URL = 'https://sales.ddsnacks.co.uk';
  REACT_APP_HOMEPAGE_URL='https://sales.ddsnacks.co.uk';
  PREFIX ='dds';
}else if (currentURL === 'dan.ramatechno.com') {
  API_URL = 'https://dan.ramatechno.com/api';
  BASE_URL = 'https://dan.ramatechno.com';
  REACT_APP_HOMEPAGE_URL = 'https://dan.ramatechno.com';
  PREFIX = 'dan';
} else if (currentURL === 'karoon.rameegroup.co.in') {
  API_URL = 'https://testapi.rameegroup.co.in';
  BASE_URL = 'https://karoon.rameegroup.co.in';
  REACT_APP_HOMEPAGE_URL = 'https://karoon.rameegroup.co.in';
  PREFIX = 'knm';
} else if (currentURL === 'tsdev.rameegroup.co.in') {
  API_URL = 'https://devapi.rameesystems.com';
  BASE_URL = 'https://tsdev.rameegroup.co.in';
  REACT_APP_HOMEPAGE_URL = 'https://tsdev.rameegroup.co.in';
  PREFIX = 'tsc';
} else if (currentURL === 'aytac.rameesystems.com') {
  API_URL = 'https://api.rameesystems.com';
  BASE_URL = 'https://aytac.rameesystems.com';
  REACT_APP_HOMEPAGE_URL = 'https://aytac.rameesystems.com';
  PREFIX = 'ayt';
} else if (currentURL === 'sales.kmfood.co.uk') {
  API_URL = 'https://api.rameesystems.com';
  BASE_URL = 'https://sales.kmfood.co.uk';
  REACT_APP_HOMEPAGE_URL = 'https://sales.kmfood.co.uk';
  PREFIX = 'knm';
} else if (currentURL === 'sales.tschilledfoods.com') {
  API_URL = 'https://api.rameesystems.com';
  BASE_URL = 'https://sales.tschilledfoods.com';
  REACT_APP_HOMEPAGE_URL = 'https://sales.tschilledfoods.com';
  PREFIX = 'tss';
} else if (currentURL === 'dds.ebusso.com') {
  API_URL = 'https://api.rameesystems.com';
  BASE_URL = 'https://dds.ebusso.com';
  REACT_APP_HOMEPAGE_URL = 'https://dds.ebusso.com';
  PREFIX = 'ddd';
}else if (currentURL === 'daninternational.rameesystems.com') 
{
  API_URL = 'https://api.rameesystems.com';
  BASE_URL = 'https://daninternational.rameesystems.com';
  REACT_APP_HOMEPAGE_URL='https://daninternational.rameesystems.com';
  PREFIX ='dan';
}else if (currentURL === 'sales.everestcashandcarryuk.com') 
{
  API_URL = 'https://api.rameesystems.com';
  BASE_URL = 'https://sales.everestcashandcarryuk.com';
  REACT_APP_HOMEPAGE_URL='https://sales.everestcashandcarryuk.com';
  PREFIX ='eve';
}else if (currentURL === 'everest.rameesystems.com') 
{
  API_URL = 'https://api.rameesystems.com';
  BASE_URL = 'https://everest.rameesystems.com';
  REACT_APP_HOMEPAGE_URL='https://everest.rameesystems.com';
  PREFIX ='eve';
}else if (currentURL === 'demo.ebusso.com') 
{
  API_URL = 'https://api.rameesystems.com';
  BASE_URL = 'https://demo.ebusso.com';
  REACT_APP_HOMEPAGE_URL='https://demo.ebusso.com';
  PREFIX ='ebu';
}
else if (currentURL === 'aytec.ramatechno.com') 
{
  API_URL = 'https://aytec.ramatechno.com/api';
  BASE_URL = 'https://aytec.ramatechno.com';
  REACT_APP_HOMEPAGE_URL='https://aytec.ramatechno.com';
  PREFIX ='ayy';
}
else if (currentURL === 'manas.rameesystems.com') 
{
  API_URL = 'https://manas.rameesystems.com/api';
  BASE_URL = 'https://manas.rameesystems.com';
  REACT_APP_HOMEPAGE_URL='https://manas.rameesystems.com';
  PREFIX ='sdm';
}
else if (currentURL === 'rhv.rameesystems.com') 
{
  API_URL = 'https://manas.rameesystems.com/api';
  BASE_URL = 'https://rhv.rameesystems.com';
  REACT_APP_HOMEPAGE_URL='https://rhv.rameesystems.com';
  PREFIX ='rhv';
}
export { API_URL, BASE_URL, REACT_APP_HOMEPAGE_URL, PREFIX };
